// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import { Stack } from '@mui/material';

// api
import { useGetV2AlarmsByIdQuery } from '@/api/generated/recalc/endpoints/v2/alarms';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';

// feature-components
import AlarmTypeVisualization from '@/features/alarm-hub/components/AlarmTypeVisualization';
import { toLegacyAlarmShape } from '@/features/alarm-hub/components/alarmTypeVisualizationShared.ts';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/alarms/$alarmId',
)({
  component: RouteComponent,
  staticData: { crumb: 'alarms:detail.title' },
});

function RouteComponent() {
  const { alarmId, accountId } = useParams({ strict: false });

  const { t } = useTranslation('alarms');

  const parsedAlarmId = Number(alarmId);
  const parsedAccountId = Number(accountId);

  const { data: alarmResponse } = useGetV2AlarmsByIdQuery(
    {
      id: parsedAlarmId,
      accountIds: Number.isFinite(parsedAccountId) ? [parsedAccountId] : [],
    },
    {
      skip: !Number.isFinite(parsedAlarmId),
    },
  );

  const alarm = toLegacyAlarmShape(alarmResponse);

  if (!alarm) return null;
  return (
    <PageContainer maxWidth="xl" sx={{ py: 2 }}>
      <PageHeader title={t('detail.title')} />
      <Stack spacing={2}>
        <AlarmTypeVisualization alarm={alarm} />
      </Stack>
    </PageContainer>
  );
}
